module.exports = {"id":"188385","name":"Marvin Martin","rating":"72","photo":"./data/images/photos/1/188385.png","club":{"name":"Stade de Reims","logo":"./data/images/clubs/StadedeReims.png"},"positions":["MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarvinMartin0.json
// module id = 2834
// module chunks = 0